import { useQuery } from '@tanstack/react-query'
import { useState } from 'react'
import { notizenZurAufgabeQuery } from '../../lib/mywork'

/**
 * **Notizen zur Aufgabe** in der Puls-Karte ([Z-24](../../../../../docs/phasen/zusatz-24-my-work.md),
 * Mockup Desktop ①). Was in My Work zur Puls-Aufgabe festgehalten wurde (`felder.aufgaben`) und
 * die Notiz, aus der sie kam. Ohne Notizbuch-Freigabe oder ohne Notizen: nichts.
 */
export function NotizenZurAufgabe({ aufgabeId }: { aufgabeId: string }) {
  const { data: notizen = [] } = useQuery(notizenZurAufgabeQuery(aufgabeId))
  const [offen, setOffen] = useState(false)
  if (notizen.length === 0) return null
  const sichtbar = offen ? notizen : notizen.slice(0, 2)
  return (
    <div className="mt-3 flex flex-col gap-1.5 rounded-[10px] bg-[#faf9f6] px-3 py-2 text-[13px]">
      <div className="text-[10.5px] font-bold tracking-[0.08em] text-ink2 uppercase">
        Notizen zur Aufgabe · {notizen.length}
      </div>
      <ul className="flex flex-col gap-1">
        {sichtbar.map((n) => {
          const wann = new Date(n.datum).toLocaleDateString('de-DE', {
            day: 'numeric',
            month: 'numeric',
          })
          const vorlaeufig = n.notizId.startsWith('neu-')
          const inhalt = (
            <>
              <span className="tabular w-[40px] shrink-0 text-[12px] text-muted">{wann}</span>
              <span className="min-w-0 flex-1">
                <span className="line-clamp-2">
                  {n.herkunft && <span className="text-muted">Herkunft · </span>}
                  {n.auszug || n.titel}
                </span>
              </span>
            </>
          )
          return (
            <li key={n.notizId}>
              {vorlaeufig ? (
                <div className="flex gap-2 opacity-60">{inhalt}</div>
              ) : (
                <a
                  href={`/notizbuch#notiz-${n.notizbuchId}-${n.notizId}`}
                  className="flex gap-2 rounded hover:text-accent-deep"
                >
                  {inhalt}
                </a>
              )}
            </li>
          )
        })}
      </ul>
      {notizen.length > 2 && (
        <button
          type="button"
          onClick={() => setOffen((x) => !x)}
          className="cursor-pointer self-start text-[12px] font-semibold text-accent-deep"
        >
          {offen ? 'weniger' : `+ ${notizen.length - 2} weitere`}
        </button>
      )}
    </div>
  )
}
